<template>
  <div class="row">
    <div class="col-lg-12">
      <card type="tasks" style="height: 700px">
        <template slot="header">
          <div class="row">
            <h4 class="card-title" style="margin-left: 18px">
              <i class="tim-icons icon-bell-55 text-primary"></i>
              控制台
            </h4>
            <div class="ml-auto">
              <div>
                <base-button
                  style="margin-right: 10px"
                  size="sm"
                  type="info"
                  @click="clearScroll"
                  >清空控制台</base-button
                >
                <base-button
                  style="margin-right: 10px"
                  size="sm"
                  type="danger"
                  @click="breakScroll"
                  >断开控制台</base-button
                >
                <base-button
                  style="margin-right: 10px"
                  size="sm"
                  :type="autoScroll ? 'warning' : 'success'"
                  @click="toggleAutoScroll"
                  >{{ scrollText }}</base-button
                >
              </div>
            </div>
          </div>
        </template>
        <div class="controlbackground">
          <div
            class="infinite-list scrollable-area"
            style="padding-right: 44px"
            ref="list"
          >
            <ul style="padding-left: 20px">
              <li v-for="message in messages" :key="message.id">
                <div
                  class="centered-content"
                  v-if="message.websocketType == 'success'"
                >
                  <badge type="success" class="font-size: 20px;margin: 0px;"
                    >系统成功消息 {{ getCurrentDateTime() }}</badge
                  >
                  <span style="margin-left: 15px; color: #00bf9a">{{
                    message.messages
                  }}</span>
                </div>

                <div
                  class="centered-content"
                  v-if="message.websocketType == 'normal'"
                  style="max-width: 100%; overflow-wrap: break-word"
                >
                  <div>
                    <badge type="warning" class="font-size: 20px;margin: 0px;"
                      >系统通知消息 {{ getCurrentDateTime() }}</badge
                    >
                  </div>

                  <div
                    style="margin-left: 15px; max-width: 100%"
                    class="breakable-content"
                  >
                    {{ message.messages }}
                  </div>
                </div>

                <div
                  class="centered-content"
                  v-if="message.websocketType == 'error'"
                  style="max-width: 100%; overflow-wrap: break-word"
                >
                  <div>
                    <badge type="danger" class="font-size: 20px;margin: 0px;"
                      >系统错误消息 {{ getCurrentDateTime() }}</badge
                    >
                  </div>
                  <div
                    style="margin-left: 15px; max-width: 100%; color: #f5365c"
                    class="breakable-content"
                  >
                    {{ message.messages }}
                  </div>
                </div>

                <div
                  class="centered-content"
                  v-if="message.websocketType == 'warn'"
                  style="max-width: 100%; overflow-wrap: break-word"
                >
                  <div>
                    <badge type="primary" class="font-size: 20px;margin: 0px;"
                      >系统警告消息 {{ getCurrentDateTime() }}</badge
                    >
                  </div>
                  <div
                    style="
                      margin-left: 15px;
                      max-width: 100%;
                      color: sandybrown;
                    "
                    class="breakable-content"
                  >
                    {{ message.messages }}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </card>
    </div>
    <card
      type="tasks"
      class="col-sm"
      style="height: auto; padding-bottom: 30px"
    >
      <template slot="header">
        <div style="">
          <div class="row">
            <div class="">
              <h4 class="title d-inline">网站管理</h4>
            </div>
            <div class="ml-auto">
              <div>
                <!-- <base-button
                  style="margin-right: 10px"
                  size="sm"
                  type="info"
                  @click="handleTuXinTianXia"
                  >图行天下登录</base-button
                > -->
                <!-- <base-button
                  style="margin-right: 10px"
                  size="sm"
                  type="default"
                  @click="handleQiantu"
                  >千图登录</base-button
                > -->
                <base-button
                  style="margin-right: 10px"
                  size="sm"
                  type="danger"
                  @click="handleXiangSheji"
                  >享设计登录</base-button
                >
                <!-- <base-button
                  style="margin-right: 10px"
                  size="sm"
                  type="primary"
                  @click="handleSheJi90"
                  >90设计登录</base-button
                >
                <base-button
                  style="margin-right: 10px"
                  size="sm"
                  type="warning"
                  @click="handleHongDongZhongGuo"
                  >红动中国登录</base-button
                > -->
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 20px">
          <base-table :data="tableData" :columns="columns">
            <template slot="columns">
              <th>id</th>
              <th>网站名称</th>
              <th>网站链接</th>
              <th>排序链接</th>
              <th>网站状态</th>
              <th>网站cookie管理</th>
            </template>
            <template slot-scope="{ row }">
              <td>{{ row.id }}</td>
              <td>{{ row.name }}</td>
              <td>{{ row.link }}</td>
              <td>{{ row.sort }}</td>
              <td>
                <base-button
                  v-if="row.state == 0"
                  style="margin-left: 6px"
                  size="sm"
                  round
                  icon
                  type="danger"
                  @click="changeSiteState(row.id)"
                  ><i class="tim-icons icon-button-pause"></i
                ></base-button>
                <base-button
                  v-if="row.state == 1"
                  style="margin-left: 6px"
                  size="sm"
                  round
                  icon
                  type="success"
                  @click="changeSiteState(row.id)"
                  ><i class="tim-icons icon-triangle-right-17"></i
                ></base-button>
              </td>
              <td>
                <base-button
                  style="margin-right: 10px"
                  size="sm"
                  type="danger"
                  @click="handleGetAllCookie(row.id)"
                  >管理cookie</base-button
                >
              </td>
            </template>
          </base-table>
        </div>
      </template>
    </card>

    <div>
      <modal
            :show.sync="modals1"
            headerClasses="justify-content-center"
            class="custom-modals modal-scroll-container"
      style="max-height:full; overflow-y: auto;"
          >
            <card >
              <h4 class="title title-up" style="text-align: center">
                cookie管理
              </h4>
          <div style="margin-top: 30px">
            <base-table :data="cookieTableData" :columns="cookieColumns">
              <template slot="columns">
                <th>id</th>
                <th>网站名称</th>
                <th>账号类型</th>
                <th>今日下载次数</th>
                <th>最大下载次数</th>
                <th>备注信息</th>
                <th v-if="hasSiteId29">购买次数</th>
                <th>状态</th>
                <th>操作</th>
              </template>
              <template slot-scope="{ row }">
                <td>{{ row.id }}</td>
                <td>{{ row.name }}</td>
                <td>
                  <badge v-if="row.cookie_type == 1" type="success">普通</badge>
                  <badge v-if="row.cookie_type == 2" type="danger"
                    >花瓣第三方</badge
                  >
                </td>
                <td>{{ row.down_num }}</td>
                <td>{{ row.max_down_num }}</td>
                <td>{{ row.description }}</td>
                <!-- 只在 site_id=29 的行显示购买栏，值为1 -->
                <td v-if="hasSiteId29">
                  <span v-if="row.site_id === 29">
                    <base-button
                      size="sm"
                      style="font-size: 0.685rem"
                      class="animation-on-hover"
                      type="danger"
                      @click="hanglePayXiangSheJi(row.id)"
                      >购买次数</base-button
                    >
                  </span>
                  <span v-else>-</span>
                </td>
                <td>
                  <base-button
                    v-if="row.state == 1"
                    style="margin-left: 6px"
                    size="sm"
                    round
                    icon
                    type="danger"
                    @click="changeCookieState(row.id, row.site_id)"
                    ><i class="tim-icons icon-button-pause"></i
                  ></base-button>
                  <base-button
                    v-if="row.state == 0"
                    style="margin-left: 6px"
                    size="sm"
                    round
                    icon
                    type="success"
                    @click="changeCookieState(row.id, row.site_id)"
                    ><i class="tim-icons icon-triangle-right-17"></i
                  ></base-button>
                </td>
                <td class="td-actions ext-center">
                  <!-- <base-button type="info" size="sm"  icon >
                    <i class="tim-icons icon-single-02" ></i>
                  </base-button> -->
                  <base-button
                    type="success"
                    style="margin-left: 6px"
                    size="sm"
                    icon
                    @click="editCookie(row.id, row.site_id)"
                  >
                    <i
                      style="color: #ffffff"
                      class="tim-icons icon-settings"
                    ></i>
                  </base-button>
                  <base-button
                    type="danger"
                    style="margin-left: 6px"
                    size="sm"
                    icon
                    @click="deleteCookie(row.id, row.site_id)"
                  >
                    <i
                      style="color: #ffffff"
                      class="tim-icons icon-simple-remove"
                    ></i>
                  </base-button>
                </td>
              </template>
            </base-table>
          </div>
        </card>
        <div
          style="
            display: flex;
            justify-content: space-between;
            margin-top: 30px;
          "
        >
          <base-button
            type="secondary"
            @click="modals1 = false"
            style="margin-right: auto"
            >取消</base-button
          >
          <base-button
            type="primary"
            style="margin-left: auto"
            @click="addCookie"
            >添加cookie</base-button
          >
        </div>
      </modal>
    </div>

    <div>
      <modal
        :show.sync="modals4"
        class="custom-modaldd"
        headerClasses="justify-content-center"
      >
        <h4 slot="header" class="title title-up">添加网站cookie</h4>
        <div>选择网站</div>
        <div>
          <el-select
            class="select-danger"
            placeholder="请选择网站"
            v-model="selects.simple"
            style="margin-top: 8px; width: 100%"
          >
            <el-option
              v-for="option in selects.languages"
              class="select-danger"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            >
            </el-option>
          </el-select>
        </div>
        <div style="margin-top: 8px">选择账号类型</div>
        <el-select
          class="select-danger"
          placeholder="请选择账号类型"
          v-model="selects1.simple"
          style="margin-top: 8px; width: 100%"
        >
          <el-option
            v-for="option in selects1.languages"
            class="select-danger"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          >
          </el-option>
        </el-select>

        <base-input
          style="margin-top: 8px"
          label="最大下载次数"
          type="number"
          placeholder="请输入最大下载次数"
          v-model="max_dowm_num"
        ></base-input>
        <base-input
          label="备注信息"
          type="text"
          placeholder="请输入备注信息"
          v-model="desc"
          style="margin-top: 8px"
        ></base-input>
        <base-input
          label="代理ip(要用 | 隔开)"
          type="text"
          placeholder="请输入代理ip 例子:115.231.22:5236|778899|778899"
          v-model="proxy"
          style="margin-top: 8px"
        ></base-input>
        <base-input label="网站对应cookie信息：">
          <textarea
            ref="myTextarea"
            v-model="cookieStr"
            style="padding: 0"
            class="form-control"
            id="exampleFormControlTextarea1"
            placeholder="请输入网站对应cookie信息"
            rows="3"
          ></textarea>
        </base-input>

        <div style="margin-top: 18px"></div>
        <template slot="footer">
          <base-button @click="doAddCookie">确定</base-button>
          <base-button type="danger" @click.native="modals4 = false"
            >取消
          </base-button>
        </template>
      </modal>
    </div>

    <div>
      <modal
        :show.sync="modals6"
        class="custom-modald"
        headerClasses="justify-content-center"
      >
        <h4 slot="header" class="title title-up">使用支付宝扫码付款</h4>

        <!-- iframe 容器 -->
        <div class="iframe-container">
          <iframe :src="payInfo" frameborder="0" class="alipay-iframe"></iframe>
        </div>

        <div style="margin-top: 18px"></div>
        <template slot="footer">
          <base-button @click.native="modals6 = false">确定</base-button>
          <base-button type="danger" @click.native="modals6 = false"
            >取消</base-button
          >
        </template>
      </modal>
    </div>

    <div>
      <modal
        :show.sync="modals5"
        class="custom-modaldd"
        headerClasses="justify-content-center"
      >
        <h4 slot="header" class="title title-up">编辑网站cookie</h4>
        <div>选择网站</div>
        <div>
          <el-select
            class="select-danger"
            placeholder="请选择网站"
            v-model="edit_selects.simple"
            style="margin-top: 8px; width: 100%"
          >
            <el-option
              v-for="option in edit_selects.languages"
              class="select-danger"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            >
            </el-option>
          </el-select>
        </div>
        <div style="margin-top: 8px">选择账号类型</div>
        <el-select
          class="select-danger"
          placeholder="请选择账号类型"
          v-model="edit_selects1.simple"
          style="margin-top: 8px; width: 100%"
        >
          <el-option
            v-for="option in edit_selects1.languages"
            class="select-danger"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          >
          </el-option>
        </el-select>

        <base-input
          style="margin-top: 8px"
          label="最大下载次数"
          type="number"
          placeholder="请输入最大下载次数"
          v-model="edit_max_dowm_num"
        ></base-input>
        <base-input
          label="备注信息"
          type="text"
          placeholder="请输入备注信息"
          v-model="edit_desc"
          style="margin-top: 8px"
        ></base-input>
        <base-input
          label="代理ip(要用 | 隔开)"
          type="text"
          placeholder="请输入代理ip 例子:115.231.22:5236|778899|778899"
          v-model="edit_proxy"
          style="margin-top: 8px"
        ></base-input>
        <base-input label="网站对应cookie信息：">
          <textarea
            ref="myTextarea"
            v-model="edit_cookieStr"
            style="padding: 0"
            class="form-control"
            id="exampleFormControlTextarea1"
            placeholder="请输入网站对应cookie信息"
            rows="3"
          ></textarea>
        </base-input>

        <div style="margin-top: 18px"></div>
        <template slot="footer">
          <base-button @click="doEditCookie">确定</base-button>
          <base-button type="danger" @click.native="modals5 = false"
            >取消
          </base-button>
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import BaseTable from "@/components/BaseTable";
import { http, locations } from "../../util/http.js";
import { Select, Option } from "element-ui";
import Swal from "sweetalert2";
import { InfiniteScroll } from "element-ui";
import Badge from "@/components/Badge";
import { getCurrentDateTime } from "../../util/utils.js";
import Modal from "@/components/Modal";
import QRCode from "qrcode";

export default {
  directives: {
    InfiniteScroll, // 在 directives 选项中注册
  },
  components: {
    Badge,
    Modal,
    BaseTable,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      messages: [],
      loading: false,
      scrollText: "停止自动滚动",
      autoScroll: true, // 控制自动滚动的标志
      ///////////
      heartBeatInterval: 30000,
      heartbeatTimer: null,
      ws: null,
      siteId: "",
      columns: ["id", "name", "link", "state"],
      tableData: [],
      cookieColumns: [
        "id",
        "cookie",
        "cookie_type",
        "down_num",
        "max_down_num",
        "proxy",
        "site_id",
        "name",
        "state",
      ],
      cookieTableData: [],
      modals1: false,
      modals4: false,
      modals5: false,
      modals6: false,
      selects: {
        simple: "",
        languages: [],
      },
      selects1: {
        simple: "",
        languages: [
          { value: "1", label: "普通类型" },
          { value: "2", label: "花瓣第三方" },
        ],
      },
      edit_selects: {
        simple: "",
        languages: [],
      },
      edit_selects1: {
        simple: "",
        languages: [
          { value: "1", label: "普通类型" },
          { value: "2", label: "花瓣第三方" },
        ],
      },
      max_dowm_num: 0,
      proxy: "",
      cookieStr: "",
      edit_max_dowm_num: 0,
      edit_proxy: "",
      edit_cookieStr: "",
      edit_cookieId: "",
      qrCodeUrl: "",
      qrCodeDataUrl: "",
      payInfo: "",
      desc: "",
      edit_desc: "",
      getCurrentDateTime,
    };
  },
  computed: {
    // 判断是否有 site_id=29 的数据
    hasSiteId29() {
      return this.cookieTableData.some((row) => row.site_id === 29);
    },
  },
  created() {
    this.connect();
  },
  mounted() {
    http
      .get("/v1/admin/getAllSite", {
        headers: { adminToken: localStorage.getItem("adminToken") },
      })
      .then((res) => {
        if (res.data.code != 200) {
          this.$notify({
            type: "danger",
            message: res.data.message,
            timeout: 2000,
            icon: "tim-icons icon-bell-55",
          });
          return;
        }
        this.tableData = res.data.data;

        let siteDataArr = [];
        res.data.data.forEach((element) => {
          siteDataArr.push({
            value: element.id,
            label: element.name,
          });
        });
        this.selects.languages = siteDataArr;
        this.edit_selects.languages = siteDataArr;
      })
      .catch((error) => {
        console.error("发生错误:", error);
        // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
      });
  },
  methods: {
    clearScroll() {
      // 清空控制台
      this.messages = [];
    },
    breakScroll() {
      // 断开控制台
      this.ws.close();
    },
    loadMore() {
      // 该方法应该负责加载更多的消息
      // 但在本例中，新消息是由 WebSocket 推送的，所以这里可能不需要做任何事情
    },
    scrollToBottom() {
      if (this.autoScroll) {
        // 仅当 autoScroll 为 true 时执行
        this.$nextTick(() => {
          const list = this.$refs.list;
          if (list) {
            list.scrollTop = list.scrollHeight;
          }
        });
      }
    },
    toggleAutoScroll() {
      if (this.autoScroll) {
        this.scrollText = "开启自动滚动";
      } else {
        this.scrollText = "停止自动滚动";
      }
      this.autoScroll = !this.autoScroll; // 切换 autoScroll 状态
    },
    handleNewMessage(data) {
      this.messages.push(data);
      // 每次接收到新消息时，滚动到底部
      this.scrollToBottom();
    },
    connect() {
      // 假设你的 WebSocket 服务运行在 ws://localhost:8080/websocket
      this.ws = new WebSocket(
        "wss://gl.nmslb.com/v1/admin/ws?adminToken=" +
          localStorage.getItem("adminToken")
      );
      this.ws.onopen = () => {
        console.log("WebSocket 连接已打开");
        // 在这里可以发送一个初始的消息
        // this.ws.send('你好，服务器！');
        this.startHeartBeat(); //开始心跳检测
      };

      this.ws.onmessage = (event) => {
        // console.log("收到消息:", event.data);
        let resData = JSON.parse(event.data);
        this.handleNewMessage(resData);
        // 这里处理接收到的消息
      };

      this.ws.onerror = (error) => {
        console.error("WebSocket 错误:", error);
        this.stopHeartBeat(); // 停止心跳检测
      };

      this.ws.onclose = (event) => {
        console.log("WebSocket 连接已关闭:", event);
        // 可以在这里处理重连逻辑
        this.stopHeartBeat(); // 停止心跳检测
      };
    },
    startHeartBeat() {
      // 设置定时心跳
      this.heartBeatTimer = setInterval(() => {
        // console.log("正在执行心跳检测");
        if (this.ws.readyState === WebSocket.OPEN) {
          // 发送心跳消息
          this.ws.send("PING");
        }
      }, this.heartBeatInterval);
    },
    stopHeartBeat() {
      // 清除定时心跳
      if (this.heartBeatTimer) {
        clearInterval(this.heartBeatTimer);
        this.heartBeatTimer = null;
      }
    },
    sendMessage(message) {
      if (this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(message);
      } else {
        console.error("WebSocket 连接未打开");
      }
    },
    handleGetAllCookie(siteId) {
      http
        .get("/v1/admin/getAllCookie?siteId=" + siteId, {
          headers: { adminToken: localStorage.getItem("adminToken") },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });
          this.modals1 = true;
          this.cookieTableData = res.data.data.cookieData;
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    handleQiantu() {
      http
        .get("/v1/admin/qianTuLogin", {
          headers: { adminToken: localStorage.getItem("adminToken") },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    handleTuXinTianXia() {
      http
        .get("/v1/admin/tuXinLogin", {
          headers: { adminToken: localStorage.getItem("adminToken") },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    handleSheJi90() {
      http
        .get("/v1/admin/sheJi90Login", {
          headers: { adminToken: localStorage.getItem("adminToken") },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    handleXiangSheji() {
      http
        .get("/v1/admin/xiangSheJiLogin", {
          headers: { adminToken: localStorage.getItem("adminToken") },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    handleHongDongZhongGuo() {
      http
        .get("/v1/admin/hongDongZhongGuoLogin", {
          headers: { adminToken: localStorage.getItem("adminToken") },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    handleXiangSheJi() {
      http
        .get("/v1/admin/xiangSheJiLogin", {
          headers: { adminToken: localStorage.getItem("adminToken") },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    handleMiYuanSu() {
      http
        .get("/v1/admin/miYuanLogin", {
          headers: { adminToken: localStorage.getItem("adminToken") },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    handleZhiShe() {
      http
        .get("/v1/admin/zhiSheLogin", {
          headers: { adminToken: localStorage.getItem("adminToken") },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    changeSiteState(id) {
      http
        .post(
          "/v1/admin/updateSite",
          {
            siteId: id,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            Swal.fire({
              icon: "error",
              title: "更改失败",
              text: res.data.message,
              customClass: {
                confirmButton: "btn btn-success btn-fill",
              },
              buttonsStyling: false,
            });
            return;
          }
          this.tableData = res.data.data;
          Swal.fire({
            icon: "success",
            title: "更改成功",
            text: res.data.message,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    changeCookieState(id, siteId) {
      http
        .post(
          "/v1/admin/changeCookieState",
          {
            cookieId: id,
            siteId: siteId,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            Swal.fire({
              icon: "error",
              title: "更改失败",
              text: res.data.message,
              customClass: {
                confirmButton: "btn btn-success btn-fill",
              },
              buttonsStyling: false,
            });
            return;
          }
          // this.tableData = res.data.data;
          Swal.fire({
            icon: "success",
            title: "更改成功",
            text: res.data.message,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
          this.cookieTableData = res.data.data.cookieData;
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    deleteCookie(id, siteId) {
      Swal.fire({
        title: "删除cookie信息",
        text: "确定需要删除该cookie信息吗?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-success btn-fill",
          cancelButton: "btn btn-danger btn-fill",
        },
        buttonsStyling: false,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then((res) => {
        if (res.isConfirmed) {
          http
            .post(
              "/v1/admin/deleteCookie",
              {
                cookieId: id,
                siteId: siteId,
              },
              { headers: { adminToken: localStorage.getItem("adminToken") } }
            )
            .then((res) => {
              if (res.data.code != 200) {
                Swal.fire({
                  icon: "error",
                  title: "cookie删除失败",
                  text: res.data.message,
                  customClass: {
                    confirmButton: "btn btn-success btn-fill",
                  },
                  buttonsStyling: false,
                });
                return;
              }
              Swal.fire({
                icon: "success",
                html: "cookie删除成功",
                customClass: {
                  confirmButton: "btn btn-success btn-fill",
                },
                buttonsStyling: false,
              });
              this.cookieTableData = res.data.data.cookieData;
            })
            .catch((error) => {
              console.error("发生错误:", error);
              // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
            });
        }
      });
    },
    addCookie() {
      this.modals4 = true;
      this.cookieStr = "";
      this.proxy = "";
    },
    doAddCookie() {
      if (this.cookieStr == "" || this.max_dowm_num == 0) {
        this.$notify({
          type: "danger",
          message: "参数不能为空",
          timeout: 2000,
          icon: "tim-icons icon-bell-55",
        });
        return;
      }
      http
        .post(
          "/v1/admin/addCookie",
          {
            siteId: this.selects.simple,
            cookieData: this.cookieStr,
            cookieType: this.selects1.simple,
            max_down_num: this.max_dowm_num,
            proxy: this.proxy,
            desc: this.desc,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.modals4 = false;
          this.cookieTableData = res.data.data.cookieData;
          Swal.fire({
            icon: "success",
            html: "套餐添加成功",
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    editCookie(cookieId) {
      this.modals5 = true;
      http
        .post(
          "/v1/admin/getCookieDetails",
          {
            cookieId: cookieId,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: "获取更新套餐列表失败",
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.edit_cookieId = cookieId;
          this.edit_max_dowm_num = res.data.data.cookieData.max_down_num;
          this.edit_proxy = res.data.data.cookieData.proxy;
          this.edit_cookieStr = res.data.data.cookieData.cookie;
          this.edit_desc = res.data.data.cookieData.description;
          this.edit_selects.simple = res.data.data.cookieData.site_id;
          this.edit_selects1.simple = res.data.data.cookieData.cookie_type + "";
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    doEditCookie() {
      if (this.edit_cookieStr == "" || this.edit_max_dowm_num == 0) {
        this.$notify({
          type: "danger",
          message: "参数不能为空",
          timeout: 2000,
          icon: "tim-icons icon-bell-55",
        });
        return;
      }
      http
        .post(
          "/v1/admin/changeCookie",
          {
            cookieId: this.edit_cookieId,
            siteId: this.edit_selects.simple,
            cookieData: this.edit_cookieStr,
            cookieType: this.edit_selects1.simple,
            max_down_num: this.edit_max_dowm_num,
            proxy: this.edit_proxy,
            edit_desc: this.edit_desc,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.modals5 = false;
          this.cookieTableData = res.data.data.cookieData;
          Swal.fire({
            icon: "success",
            html: "修改成功",
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    async hanglePayXiangSheJi(cookieId) {
      try {
        const res = await http.post(
          "/v1/admin/payXiangSheJi",
          { cookieId: cookieId },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        );

        if (res.data.code != 200) {
          this.$notify({
            type: "danger",
            message: res.data.message,
            timeout: 2000,
            icon: "tim-icons icon-bell-55",
          });
          return;
        }
        // 获取返回的二维码链接
        // const qrCodeLink = res.data.data; // 或者 res.data.qRCode，根据实际返回结构调整

        // // 生成二维码图片 Data URL
        // const qrCodeDataUrl = await QRCode.toDataURL(qrCodeLink, {
        //   width: 250, // 二维码宽度
        //   margin: 2,  // 边距
        //   errorCorrectionLevel: 'H', // 纠错级别
        //   color: {
        //     dark: '#000000',  // 黑色部分
        //     light: '#ffffff'  // 白色部分
        //   }
        // });

        // 保存二维码数据到 data
        // this.qrCodeUrl = qrCodeDataUrl;
        this.payInfo = res.data.data;

        this.$notify({
          type: "success",
          message: "获取成功",
          timeout: 3000,
          icon: "tim-icons icon-bell-55",
        });

        // 打开弹窗
        this.modals6 = true;

        console.log(res.data.data);
      } catch (error) {
        console.error("发生错误:", error);
        this.$notify({
          type: "danger",
          message: "生成二维码失败",
          timeout: 2000,
          icon: "tim-icons icon-bell-55",
        });
      }
    },
  },
  beforeDestroy() {
    if (this.ws) {
      this.ws.close(); // 在组件销毁之前关闭 WebSocket 连接
      // 清除心跳包定时器
      this.stopHeartBeat();
    }
  },
  watch: {
    // 假设有一个数据列表，当它更新时会触发滚动到底部
    yourDataList: {
      handler() {
        this.scrollToBottom();
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.modal-content {
  width: 800px;
}

.controlbackground {
  background-color: black;
  border-radius: 5px;
  width: 100%;
  height: 100%;
}
.infinite-list {
  height: 100%;
  overflow-y: auto;
}

li {
  list-style-type: none;
}

/* 滚动区域默认不显示滚动条 */
.scrollable-area {
  overflow: hidden; /* 隐藏滚动条 */
}

/* 滚动区域悬停时显示滚动条 */
.scrollable-area:hover {
  overflow-y: scroll; /* 显示竖直滚动条 */
}

/* 滚动条整体部分 */
.scrollable-area:hover::-webkit-scrollbar {
  width: 12px;
}

/* 滚动条滑块 */
.scrollable-area:hover::-webkit-scrollbar-thumb {
  background-color: white;
  border-radius: 6px;
  border: 3px solid transparent;
  background-clip: content-box;
}

/* 滚动条轨道 */
.scrollable-area:hover::-webkit-scrollbar-track {
  background: rgba(252, 252, 252, 0.2);
  border-radius: 6px;
}

.centered-content {
  /* display: flex; */
  /* align-items: center; */
  color: #fff; /* 移动到这里来应用于所有的 li */
  margin-top: 10px;

  display: flex;
  flex-direction: row; /* 确保元素水平排列 */
  align-items: center; /* 元素垂直居中 */
  justify-content: flex-start; /* 从左到右排列 */
  width: 100%; /* 或你的期望宽度 */
}

.badge {
  margin-bottom: 0;
}
.breakable-content {
  white-space: normal; /* 允许根据内容自动换行 */
  overflow-wrap: break-word; /* 确保长单词能够被折行 */
  word-break: break-all; /* 在需要时强制折行 */
}

.badge-primary {
  background-color: sandybrown;
}



/* 在当前页面实现 modal-content 距离底部 200px */
.custom-modals >>> .modal-content {
  margin-bottom: 200px !important;
}

/* 或者如果需要保持居中同时距离底部200px */
.custom-modals >>> .modal-dialog {
  display: flex;
  align-items: flex-end; /* 改为底部对齐 */
  min-height: calc(100% - 200px);
  margin: 0 auto;
}

/* 如果上面方法不生效，可以尝试这个 */
.custom-modals >>> .modal {
  display: flex !important;
  align-items: flex-end !important;
  justify-content: center !important;
  padding-bottom: 200px !important;
}

/* 或者最简单的方案 - 直接设置modal-dialog的margin-top */
.custom-modals >>> .modal-dialog {
  margin-top: calc(100vh - 200px - 80vh) !important; /* 动态计算 */
  margin-bottom: 200px !important;
}

</style>

<style>
.pagination-select,
.search-input {
  width: 200px;
}

.custom-modals .modal-dialog {
  max-width: 1600px !important; /* 覆盖全局样式 */
}

.custom-modaldd .modal-dialog {
  max-width: 800px !important; /* 覆盖全局样式 */
}

.custom-modald .modal-dialog {
  max-width: 1600px !important; /* 覆盖全局样式 */
  max-height: 1600px !important; /* 覆盖全局样式 */
}

/* iframe 容器样式 */
.iframe-container {
  width: 100%;
  height: 900px; /* 设置固定高度，或根据需要调整 */
  overflow: hidden;
  position: relative;
}

/* iframe 样式 */
.alipay-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>


<style scoped lang="scss" >
.pagination-select,
.search-input {
  width: 200px;
}
// ::v-deep .modal-dialog {
//   max-width: 1500px !important;
// }
</style>

 